(function() { window.GUID_b73f52c0_ccd8_43ae_b6de_6d9d869e852c = { getGuid: function() { return "b73f52c0-ccd8-43ae-b6de-6d9d869e852c"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class HorizontalScroller extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                let me = this;
                me.controlId = params[0];
                me.$control = $("#" + params[0]); //contient le Id
                me.$control.addClass("horizontal-scroller");
                me.$control.wrapInner("<div class='horizontal-scroller-content'></div>");
                me.$content = me.$Control.children(".horizontal-scroller-content");
                let $scrollToElement = me.$Control.find(".scroll-to");
                $(document).ready(function () {
                    me.ScrollToItem($scrollToElement);
                    me.$Control.css("opacity", 1);
                });
                //CS.Helper.RenderingHelper.IsRendered(me.$Control, function () {
                //    me.ScrollToItem($scrollToElement);
                //    me.$Control.css('opacity', 1);
                //});
            }
            OnDispose() {
                this.$content.off("scroll." + this.controlId);
                this.$Control.remove();
            }
            OnBindEvents() {
                let scrolled = false;
                let me = this;
                me.$content.offon("scroll." + me.controlId, () => {
                    if (scrolled) {
                        return;
                    }
                    scrolled = true;
                    CS.Analytics.Event("HorizontalScroller", "Scroll", me.ControlId);
                });
            }
            ScrollToItem($element) {
                if ($element.length > 0) {
                    this.$content.scrollLeft($element.position().left - this.$Control.position().left - 30);
                }
            }
        }
        Controls.HorizontalScroller = HorizontalScroller;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=horizontal-scroller.js.map
